import React, { useState } from "react";
import { ConfigProvider, TimePicker } from "antd";
import dayjs, { utc } from "dayjs";
import timezone from "dayjs/plugin/timezone";
import "dayjs/locale/en";
import customParseFormat from "dayjs/plugin/customParseFormat";
import Cookies from "universal-cookie";

dayjs.extend(customParseFormat);
dayjs.extend(utc);
dayjs.extend(timezone);

const SingleTimePicker = ({ defaultValue = null, handleOnChange, isEndTime = false }) => {
  const cookies = new Cookies();
  const timezone = cookies.get("timeZone") || "UTC";

  const [time, setTime] = useState(
    defaultValue
      ? dayjs.tz(defaultValue, "hh:mm A", timezone)
      : null
  );

  const onChange = (val) => {
    if (!val) {
      setTime(null);
      handleOnChange(null);
      return;
    }
    const localTime = val.tz(timezone).second(0); // force seconds = 00
    setTime(localTime);
    handleOnChange(localTime);
  };

  const disabledTime = () => {
    if (!isEndTime) return {};
    return {
      disabledMinutes: (selectedHour) => (selectedHour === 0 ? [0] : []),  // disable only 12:00 AM
    };
  };

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#4F44E0",
        },
      }}
    >
      <TimePicker
        value={time}
        onChange={onChange}
        format="hh:mm A"
        use12Hours
        minuteStep={1}
        placeholder="HH:MM"
        popupClassName="custom-timepicker-popup"
        style={{ width: '100%' }}
        disabledTime={disabledTime}
      />
    </ConfigProvider>
  );
};

export default SingleTimePicker;
